module.exports = __webpack_public_path__ + "static/img/fefco205_2.b9cdc98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/fefco205_2.png
// module id = mW0U
// module chunks = 0